import { BrandSelect, CategoryWithSubCategorySelect } from "./Selectors"
import Deletor from "./Deletor"
import { useState, useEffect, useRef } from "react"
import { useAuthAxios } from "../authfetch"
import { apiurl, staticurl } from "../../common/constants"
import { useStore } from "../../context/StoreContext"
import { useAuth } from '@clerk/clerk-react'

// sub component edit product detail modal
const EditProductDetail = (props) => {
    const { brands, categories, productRefresh, setProductRefresh } = useStore();
    const { currentSelectedProduct,setCurrentSelectedProduct } = useStore();
    const authAxios = useAuthAxios();
    const { getToken } = useAuth();

    const [name, setName] = useState("");
    const [desc, setDesc] = useState("");
    const [brand, setBrand] = useState("");
    const [category, setCategory] = useState("");
    const [stock, setStock] = useState(0);
    const [price, setPrice] = useState(0);
    const [discountedPrice, setDiscountedPrice] = useState(0);
    const [pre_order, setPreOrder] = useState(false);
    const [selectedThumbnail, setSelectedThumbnail] = useState(null);
    
    const fileInputRef = useRef(null);

    useEffect(() => {
        if (currentSelectedProduct) {
            setName(currentSelectedProduct.prod_name || "");
            setDesc(currentSelectedProduct.prod_desc || "");

            // Safely handle brand_ref
            let bId = currentSelectedProduct.brand_ref;
            if (bId && typeof bId === 'object') bId = bId._id;
            setBrand(bId || "");

            // Safely handle category/subcategory ref
            let cVal = "";
            if (currentSelectedProduct.subcategories_ref) {
                let sId = currentSelectedProduct.subcategories_ref;
                if (sId && typeof sId === 'object') sId = sId._id;
                cVal = "S" + sId;
            } else if (currentSelectedProduct.category_ref) {
                let cId = currentSelectedProduct.category_ref;
                if (cId && typeof cId === 'object') cId = cId._id;
                cVal = "M" + cId;
            }
            setCategory(cVal);

            setStock(currentSelectedProduct.stock ?? 0);
            setPrice(currentSelectedProduct.price ?? 0);
            setDiscountedPrice(currentSelectedProduct.discounted_price ?? 0);
            setPreOrder(currentSelectedProduct.pre_order ?? false);
            
            // Reset selection - default to first image if exists
            if (currentSelectedProduct.prod_img && currentSelectedProduct.prod_img.length > 0) {
                 setSelectedThumbnail(currentSelectedProduct.prod_img[0]);
            } else {
                 setSelectedThumbnail(null);
            }
            
            if(fileInputRef.current) fileInputRef.current.value = "";
        }
    }, [currentSelectedProduct])

    const closeEditModel = () => {
        const closeBtn = document.querySelector('#editProductDetailModel .btn-close');
        if (closeBtn) {
            closeBtn.click();
        }
    }

    const handleEditProduct = (e) => {
        e.preventDefault()
        
        // Reorder images if a new thumbnail is selected
        let images = [...(currentSelectedProduct.prod_img || [])];
        if (selectedThumbnail) {
            const index = images.indexOf(selectedThumbnail);
            if (index !== -1) {
                images.splice(index, 1);
                images.unshift(selectedThumbnail);
            }
        }

        const formData = new FormData()
        formData.append("_id", currentSelectedProduct._id)
        
        if (fileInputRef.current && fileInputRef.current.files[0]) {
            formData.append("new_prod_image_add", fileInputRef.current.files[0])
        }
        
        formData.append("prod_name", name)
        formData.append("prod_desc", desc)
        formData.append("prod_img", JSON.stringify(images))
        
        if(images.length > 0) {
            formData.append("prod_thumbnail", images[0].replace("/products/", "/thumbnails/"))
        }
        
        formData.append("brand_ref", brand)
        formData.append("category_ref", category)
        formData.append("new_stock", stock)
        formData.append("new_price", price)
        formData.append("new_discounted_price", discountedPrice)
        formData.append("pre_order", pre_order)

        const submitProduct = async () => {
            try {
                const token = await getToken();
                const { data } = await authAxios.put(apiurl + "/products", formData, {
                    headers: { 
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Bearer ${token}`
                    }
                });
                if (data.data) {
                    setCurrentSelectedProduct(data.data)
                }
                setProductRefresh(productRefresh + 1)
                alert(data.message)
                closeEditModel();
            } catch (err) {
                console.log(err)
            }
        };
        submitProduct();
    }

    const handleDeleteProduct = async (e) => {
        e.preventDefault()
        const confirm = window.confirm(`are you sure you want to delete ${currentSelectedProduct.prod_name}`)
        if (!confirm) return
        
        try {
            const { data } = await authAxios.delete(apiurl + "/products", {
                data: { _id: currentSelectedProduct._id }
            });
            alert(data.message)
            closeEditModel();

            // show latest products when no project if found
            const similarProductCount = 6
            const { data: searchData } = await authAxios.post(`${apiurl}/search`, {
                productPerPage: similarProductCount,
                latest: true
            });
            props.setSimilarProduct(searchData.data)
        } catch (err) {
            console.log(err)
        }
    }

    return (
        <>
            <div className="modal fade" id="editProductDetailModel" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content shadow">
                        <div className="modal-header border-0 pb-0">
                            <h1 className="modal-title fs-4 fw-bold heading-font" id="exampleModalLabel">Edit Product</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body pt-4">
                            <form className='editProductForm' onSubmit={handleEditProduct}>
                                <div className="row g-3">
                                    {/* Name */}
                                    <div className="col-12">
                                        <div className="form-floating">
                                            <input 
                                                required 
                                                type="text" 
                                                className="form-control new_prod_name" 
                                                id="prodNameInput"
                                                placeholder="Product Name" 
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                            <label htmlFor="prodNameInput">Product Name</label>
                                        </div>
                                    </div>

                                    {/* Description */}
                                    <div className="col-12">
                                        <div className="form-floating">
                                            <textarea 
                                                required 
                                                className="form-control new_prod_desc" 
                                                placeholder='Product Description' 
                                                id="prodDescInput"
                                                style={{ height: "120px" }}
                                                value={desc}
                                                onChange={(e) => setDesc(e.target.value)}
                                            ></textarea>
                                            <label htmlFor="prodDescInput">Description</label>
                                        </div>
                                    </div>

                                    {/* Brand & Category */}
                                    <div className="col-12 col-md-6">
                                        <div className="form-floating">
                                            <BrandSelect 
                                                brandId="editProductBrand" 
                                                brands={brands} 
                                                onChange={(val) => setBrand(val)}
                                                value={brand}
                                            />
                                            <label htmlFor="editProductBrand">Brand</label>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-floating">
                                            <CategoryWithSubCategorySelect
                                                firstOption="Select Category"
                                                disableFirstOption={true}
                                                selectId="editProductCategory" 
                                                categories={categories}
                                                onChange={(val) => setCategory(val)}
                                                value={category}
                                            />
                                            <label htmlFor="editProductCategory">Category</label>
                                        </div>
                                    </div>

                                    {/* Stock & Price */}
                                    <div className="col-6">
                                        <div className="form-floating">
                                            <input 
                                                required 
                                                type="number" 
                                                className="form-control new_prod_stock" 
                                                placeholder="Stock" 
                                                id="prodStockInput"
                                                min='0' 
                                                value={stock}
                                                onChange={(e) => setStock(e.target.value)}
                                            />
                                            <label htmlFor="prodStockInput">Stock</label>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-floating">
                                            <input 
                                                required 
                                                type="number" 
                                                className="form-control new_prod_price" 
                                                placeholder="Price" 
                                                id="prodPriceInput"
                                                min='0' 
                                                value={price}
                                                onChange={(e) => setPrice(e.target.value)}
                                            />
                                            <label htmlFor="prodPriceInput">Price (Rs.)</label>
                                        </div>
                                    </div>
                                    
                                    {/* Discounted Price */}
                                    <div className="col-6">
                                        <div className="form-floating">
                                            <input 
                                                required 
                                                type="number" 
                                                className="form-control new_prod_discounted_price" 
                                                placeholder="Discounted Price" 
                                                id="prodDiscountInput"
                                                min='0' 
                                                value={discountedPrice}
                                                onChange={(e) => setDiscountedPrice(e.target.value)}
                                            />
                                            <label htmlFor="prodDiscountInput">Discounted Price (Rs.)</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-check form-switch mb-3">
                                    <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="preOrderSwitch"
                                    name="pre_order"
                                    checked={pre_order}
                                    onChange={(e) => setPreOrder(e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor="preOrderSwitch">
                                    Pre Order
                                    </label>
                                </div>
                                <hr className="my-4 opacity-10" />

                                {/* Images */}
                                <div className="mb-3">
                                    <label className="form-label fw-bold">Thumbnail Selection</label>
                                    <p className="text-muted small mb-2">Click on an image to set it as the main thumbnail (highlighted in blue).</p>
                                    
                                    <div className="d-flex flex-wrap gap-3 align-items-stretch">
                                        {currentSelectedProduct && currentSelectedProduct.prod_img.map((img, index) => (
                                            <div 
                                                key={index} 
                                                className={`position-relative text-center border rounded p-2 bg-light cursor-pointer transition-all ${selectedThumbnail === img ? 'border-primary shadow-sm border-2' : ''}`}
                                                style={{cursor: 'pointer', transition: 'all 0.2s', minWidth: '100px'}}
                                                onClick={() => setSelectedThumbnail(img)}
                                            >
                                                {/* Hidden Radio for accessibility logic if needed, but UI is driven by div click */}
                                                <input 
                                                    type="radio" 
                                                    name="new_product_thumbnail" 
                                                    value={img} 
                                                    checked={selectedThumbnail === img}
                                                    onChange={() => setSelectedThumbnail(img)}
                                                    className="d-none"
                                                />
                                                
                                                {selectedThumbnail === img && (
                                                    <div className="position-absolute top-0 end-0 p-1">
                                                        <i className="fa-solid fa-circle-check text-primary"></i>
                                                    </div>
                                                )}

                                                <img src={staticurl + img} alt="prodThumbnail" style={{height: '80px', width: 'auto', objectFit: 'contain'}} className="mb-2 mt-2 d-block mx-auto"/>
                                                
                                                <div 
                                                    className="" 
                                                    onClick={(e) => e.stopPropagation()} /* Prevent selecting when clicking delete */
                                                >
                                                    <Deletor
                                                        img={img}
                                                        prodId={currentSelectedProduct._id}
                                                        index={index}
                                                        callback={closeEditModel}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="mt-3">
                                        <label htmlFor="addNewProdImage" className="form-label">Add New Image</label>
                                        <input 
                                            className="form-control" 
                                            type="file" 
                                            id="addNewProdImage" 
                                            ref={fileInputRef}
                                        />
                                    </div>
                                </div>
                                
                                {/* Footer Actions */}
                                <div className="d-flex justify-content-between mt-4 border-top pt-3">
                                    <button type="button" className="btn btn-outline-danger" onClick={handleDeleteProduct}>
                                        <i className="fa-solid fa-trash-can me-2"></i> Delete Product
                                    </button>
                                    <button type="submit" className="btn btn-dark px-4">
                                        <i className="fa-solid fa-floppy-disk me-2"></i> Save Changes
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditProductDetail